import processName from './processName';

const validateText = (text, options = {}) => {
    const { // 기본 설정
        minLength = 0,
        maxLength = 50,
        specialCharList = /[\\/:*?"<>|#%&{}^~]/,
        specialChars = true,
        continuousChars = true,
        emptyText = true,
        ignoreExtension = false,
        includeEmptyText = false
    } = options;
    
    const processedText = ignoreExtension
        ? processName(text)
        : text.normalize('NFC');

    const textLength = processedText.length;

    const trimmedText = processedText.trim();
  
    // 1. 글자수 체크
    if (textLength < minLength || textLength > maxLength) {
        return {
            isValid: false
        };
    }
  
    // 2. 특수문자 체크
    if (specialChars) {
        if (specialCharList.test(processedText)) {
            return {
                isValid: false
            };
        }
    }
  
    // 3. 연속된 특수문자 체크
    if (continuousChars) {
        if (processedText.includes('--') || processedText.includes('__')) {
            return {
                isValid: false
            };
        }
    }
  
    // 4. 빈 문자열 체크
    if (emptyText) {
        if (trimmedText === '') {
            return {
                isValid: false
            };
        }
    }

    // 5. 빈 문자열 포함 체크
    if (includeEmptyText) {
        if (processedText.includes(' ')) {
            return {
                isValid: false
            };
        }
    }

    return { // 모든 검증 통과
        isValid: true
    };
};

export default validateText;
